module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-500.9ab383db.ttf";